/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, ElementRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UiRadio } from '../../ui-radio/ui-radio';
import { Mixin } from '../../../mixins/Mixin';
import { Filterable } from '../../../mixins/Filterable';

@Component({
    selector: 'fe-radio',
    template: require('./fe-radio.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeRadio, multi: true}
    ],
})

@Mixin([Filterable])
export class FeRadio extends UiRadio {

    @ViewChild(UiRadio) innerUiRadio: UiRadio;

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-radio/fe-radio.ts